import { render } from "./LevelsListPage.vue?vue&type=template&id=3cad5626&ts=true"
import script from "./LevelsListPage.vue?vue&type=script&lang=ts"
export * from "./LevelsListPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__